import React, { useEffect, useState, lazy, createElement } from 'react';
import { MapPin, Plus, Minus, Check, Lock, Zap, Shield, CreditCard, Star } from 'lucide-react';
// --- COMPONENTS ---
function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  const names = ['Mariela G.', 'Juan P.', 'Laura M.', 'Carlos S.', 'Florencia L.', 'Diego R.', 'Ana V.', 'Martín C.'];
  const cities = ['Córdoba', 'Rosario', 'Buenos Aires', 'Mendoza', 'Tucumán', 'Salta', 'Santa Fe', 'Mar del Plata'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4000);
    };
    const initialTimer = setTimeout(showPopup, 5000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-0">
      <div className="bg-white border border-[#E7DDD0] rounded-xl p-4 shadow-2xl flex items-center gap-4 max-w-xs sm:max-w-sm" data-id="element-1">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E8623F] to-[#D8512F] flex items-center justify-center text-white font-bold flex-shrink-0" data-id="element-2">
          {data.name.charAt(0)}
        </div>
        <div data-id="element-3">
          <p className="text-sm text-[#2B2330]" data-id="element-4">
            <span className="font-bold" data-id="element-5">{data.name}</span> compró el Pack
            Completo
          </p>
          <p className="text-xs text-slate-500 flex items-center gap-1 mt-1" data-id="element-6">
            <MapPin size={12} data-id="element-7" /> {data.city}, Argentina
          </p>
        </div>
      </div>
    </div>;
}
function CountdownTimer({
  hours = 23,
  minutes = 55,
  seconds = 51
}) {
  const [timeLeft, setTimeLeft] = useState(hours * 3600 + minutes * 60 + seconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const fmt = (n: number) => String(n).padStart(2, '0');
  return <div className="flex justify-center gap-3 sm:gap-4 flex-wrap" data-id="element-8">
      <div className="bg-[#3E1B38] border border-[#703B5D] rounded-2xl p-4 sm:p-5 min-w-[80px] sm:min-w-[100px] text-center" data-id="element-9">
        <strong className="block text-4xl sm:text-5xl font-black bg-gradient-to-br from-[#F28A6F] to-[#E8623F] bg-clip-text text-transparent leading-none" data-id="element-10">
          {fmt(h)}
        </strong>
        <span className="text-[10px] sm:text-xs text-[#EADCD3] uppercase tracking-widest font-bold mt-2 block" data-id="element-11">
          Horas
        </span>
      </div>
      <div className="bg-[#3E1B38] border border-[#703B5D] rounded-2xl p-4 sm:p-5 min-w-[80px] sm:min-w-[100px] text-center" data-id="element-12">
        <strong className="block text-4xl sm:text-5xl font-black bg-gradient-to-br from-[#F28A6F] to-[#E8623F] bg-clip-text text-transparent leading-none" data-id="element-13">
          {fmt(m)}
        </strong>
        <span className="text-[10px] sm:text-xs text-[#EADCD3] uppercase tracking-widest font-bold mt-2 block" data-id="element-14">
          Min
        </span>
      </div>
      <div className="bg-[#3E1B38] border border-[#703B5D] rounded-2xl p-4 sm:p-5 min-w-[80px] sm:min-w-[100px] text-center" data-id="element-15">
        <strong className="block text-4xl sm:text-5xl font-black bg-gradient-to-br from-[#F28A6F] to-[#E8623F] bg-clip-text text-transparent leading-none" data-id="element-16">
          {fmt(s)}
        </strong>
        <span className="text-[10px] sm:text-xs text-[#EADCD3] uppercase tracking-widest font-bold mt-2 block" data-id="element-17">
          Seg
        </span>
      </div>
    </div>;
}
function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo recibo el MegaPack después de comprar?',
    a: 'Inmediatamente después de confirmar el pago recibís un email con el link de descarga. En menos de 5 minutos tenés todo el material en tu dispositivo.'
  }, {
    q: '¿Sirve para mi provincia?',
    a: 'Sí. El material está alineado a los NAP y al currículum nacional. Funciona en todas las provincias argentinas, con contenidos de folclore y música regional integrados.'
  }, {
    q: '¿Está en blanco y negro?',
    a: 'Sí. Todo el material está optimizado para fotocopiadora en blanco y negro. Sin degradados, sin fondos oscuros. Pensado para la realidad de las escuelas argentinas.'
  }, {
    q: '¿Los 6 bonus están en todas las ofertas?',
    a: 'Sí. Los 6 bonus están incluidos en las 3 opciones sin costo adicional. Los Ebooks Elite (Actos y ESI+EAI) están solo en el Pack Completo.'
  }, {
    q: '¿Puedo comprar Primaria ahora y Secundaria después?',
    a: 'Sí. Podés comprar por separado. Si después querés el Pack Completo, escribinos y te hacemos el precio diferencial descontando lo que ya pagaste.'
  }, {
    q: '¿Los Ebooks Elite están en todas las ofertas?',
    a: 'No. Los Ebooks Elite (Sistema de Actos Escolares + Proyectos ESI y EAI) están incluidos únicamente en el Pack Completo de $27.990 ARS.'
  }, {
    q: '¿Está actualizado al currículum vigente?',
    a: 'Sí. El material está alineado a los NAP y a los lineamientos jurisdiccionales vigentes, incluyendo los ejes de ESI y EAI como exige la normativa actual.'
  }, {
    q: '¿Qué pasa si no tengo internet en la escuela?',
    a: 'No hay problema. Descargás los PDFs una sola vez y los tenés para siempre en tu dispositivo. No necesitás conexión para usarlos en el aula.'
  }, {
    q: '¿Tiene garantía real?',
    a: '100% real. Si en 7 días no estás conforme, te devolvemos el dinero completo sin preguntas ni formularios. Escribís un mensaje y listo.'
  }, {
    q: '¿Qué diferencia tiene con otros packs que vi?',
    a: 'Tres diferencias clave: 1) Está organizado por grado y año específico, no por ciclo genérico. 2) Integra folclore argentino y músicas actuales aptas para el aula. 3) Incluye los Ebooks Elite de Actos y de ESI+EAI que no existen en ningún otro pack del mercado.'
  }];
  return <div className="flex flex-col gap-3 mt-12 text-left" data-id="element-18">
      {faqs.map((faq, i) => <div key={i} className="bg-white border border-[#E7DDD0] rounded-2xl overflow-hidden shadow-sm" data-id="element-19">
          <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-5 sm:px-6 flex justify-between items-center gap-4 text-left hover:bg-slate-50 transition-colors" data-id="element-20">
            <span className="text-base font-bold text-[#2B2330]" data-id="element-21">{faq.q}</span>
            <span className="text-[#E8623F] flex-shrink-0" data-id="element-22">
              {openIndex === i ? <Minus size={20} data-id="element-23" /> : <Plus size={20} data-id="element-24" />}
            </span>
          </button>
          {openIndex === i && <div className="px-5 sm:px-6 pb-5 text-[15px] text-slate-600 leading-relaxed border-t border-[#E7DDD0] pt-4" data-id="element-25">
              {faq.a}
            </div>}
        </div>)}
    </div>;
}
// --- MAIN APP ---
export function App() {
  // Meta Pixel
  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;
      // @ts-ignore
      if (window.fbq) return;
      // @ts-ignore
      const n: any = function () {
        // @ts-ignore
        n.callMethod ?
        // @ts-ignore
        n.callMethod.apply(n, arguments) :
        // @ts-ignore
        n.queue.push(arguments);
      };
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // @ts-ignore
      window.fbq = n;
      // @ts-ignore
      if (!window._fbq) window._fbq = n;
      // Queue events immediately so they fire as soon as the script loads
      // @ts-ignore
      window.fbq('init', '2124467298394330');
      // @ts-ignore
      window.fbq('track', 'PageView');
      // Defer loading the actual fbevents.js script until the browser is idle,
      // so it doesn't compete with the LCP / first paint.
      const loadPixelScript = () => {
        try {
          const t = document.createElement('script');
          t.async = true;
          t.src = 'https://connect.facebook.net/en_US/fbevents.js';
          t.onerror = () => {
            // Silently ignore script load errors (e.g., blocked by ad blocker or sandbox)
          };
          const s = document.getElementsByTagName('script')[0];
          if (s && s.parentNode) {
            s.parentNode.insertBefore(t, s);
          } else {
            document.head.appendChild(t);
          }
        } catch (e) {
          // Swallow script injection errors
        }
      };
      // @ts-ignore
      if (typeof window.requestIdleCallback === 'function') {
        // @ts-ignore
        window.requestIdleCallback(loadPixelScript, {
          timeout: 3000
        });
      } else {
        setTimeout(loadPixelScript, 1500);
      }
    } catch (e) {
      // Swallow any pixel init errors
    }
  }, []);
  // Pixel event helper
  const trackPixel = (event: string, params?: Record<string, any>) => {
    try {
      if (typeof window === 'undefined') return;
      // @ts-ignore
      if (typeof window.fbq !== 'function') return;
      // @ts-ignore
      if (params) window.fbq('track', event, params);
      // @ts-ignore
      else window.fbq('track', event);
    } catch (e) {
      // Swallow tracking errors
    }
  };
  const checkoutUrls = {
    primaria: 'https://docente360.com.ar/checkouts/cn/hWNEGH7mVaBI7epFoEC6NV3a/en-ar?_r=AQABJgCMGBwljeh1XwBmny70H1EovkBbXYcMchBbkSlerjA',
    completo: 'https://docente360.com.ar/checkouts/cn/hWNEGH8A7rrbt6sXBIIhxzlK/en-ar?_r=AQABU4dTxDRR5QCw-i4Ora25l45Gf5XNKEZnaGUJ1FdZJYw',
    secundaria: 'https://docente360.com.ar/checkouts/cn/hWNEGH7yrWvuSdeLd7wxmIhW/en-ar?_r=AQABorVlwvaR7yNKHn1W-1vLawo7ZtDh_s1JENB8fp0qwN0'
  } as const;
  const packLabels = {
    primaria: 'SÍ, QUIERO PRIMARIA',
    completo: 'SÍ, QUIERO PACK COMPLETO',
    secundaria: 'SÍ, QUIERO SECUNDARIA'
  } as const;
  const packHelperText = {
    primaria: 'Acceso inmediato a los 6 tomos de Primaria + 6 bonus',
    completo: 'La opción más elegida por docentes que enseñan en los dos niveles',
    secundaria: 'Acceso inmediato a los 6 tomos de Secundaria + 6 bonus'
  } as const;
  const packMeta = {
    primaria: {
      content_ids: ['music-pro-primaria'],
      content_name: 'MegaPack Music Pro - Primaria',
      content_type: 'product',
      value: 16990,
      currency: 'ARS'
    },
    completo: {
      content_ids: ['music-pro-pack-completo'],
      content_name: 'MegaPack Music Pro - Pack Completo',
      content_type: 'product',
      value: 27990,
      currency: 'ARS'
    },
    secundaria: {
      content_ids: ['music-pro-secundaria'],
      content_name: 'MegaPack Music Pro - Secundaria',
      content_type: 'product',
      value: 18990,
      currency: 'ARS'
    }
  } as const;
  const [selectedPack, setSelectedPack] = useState<keyof typeof checkoutUrls>('completo');
  // Fire ViewContent when pricing section becomes visible
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const el = document.getElementById('pricing');
    if (!el || typeof IntersectionObserver === 'undefined') return;
    let fired = false;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !fired) {
          fired = true;
          trackPixel('ViewContent', {
            content_name: 'Pricing Section',
            content_category: 'pricing',
            currency: 'ARS'
          });
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.3
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const handleSelectPack = (pack: keyof typeof checkoutUrls) => {
    setSelectedPack(pack);
    trackPixel('AddToCart', packMeta[pack]);
  };
  const handleCheckoutClick = (pack: keyof typeof checkoutUrls) => {
    trackPixel('InitiateCheckout', packMeta[pack]);
  };
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    e.preventDefault();
    trackPixel('Lead', {
      content_name: 'Scroll to Pricing CTA',
      content_category: 'landing-page-cta'
    });
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#FBF7F0] text-[#2B2330] font-sans overflow-x-hidden selection:bg-[#E8623F]/20" data-id="element-26">
      <PurchasePopup data-id="element-27" />

      {/* HERO */}
      <section className="relative bg-gradient-to-br from-[#5B2A4E] via-[#4A233E] to-[#3E1B38] pt-8 pb-8 sm:pt-16 sm:pb-20 px-4 sm:px-6 text-center overflow-hidden" data-id="element-28">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(232,98,63,0.15)_0%,transparent_60%)] pointer-events-none" data-id="element-29"></div>

        <div className="relative z-10 max-w-4xl mx-auto" data-id="element-30">
          <div className="inline-block bg-[#E8623F]/20 border border-[#E8623F]/40 text-[#F28A6F] sm:bg-gradient-to-br sm:from-[#E8623F] sm:to-[#D8512F] sm:text-white sm:border-0 px-4 py-1.5 sm:px-5 sm:py-2 rounded-full text-[12px] sm:text-[13px] font-extrabold tracking-wider sm:tracking-wide uppercase mb-4 sm:mb-6" data-id="element-31">
            TODO TU AÑO DE MÚSICA RESUELTO.
          </div>

          <h1 className="text-[30px] sm:text-[clamp(28px,5vw,56px)] font-black leading-[1.1] mb-5 sm:mb-4 text-left sm:text-center font-['Playfair_Display',serif]" data-id="element-32">
            <span className="sm:hidden" data-id="element-33">
              <span className="text-[#FBF7F0]" data-id="element-34">
                MegaPack Music Pro — 12 tomos completos{' '}
              </span>
              <span className="bg-gradient-to-br from-[#F28A6F] via-[#E8623F] to-[#D8512F] bg-clip-text text-transparent" data-id="element-35">
                para docentes de primaria y secundaria
              </span>
            </span>
            <span className="hidden sm:inline text-[#FBF7F0]" data-id="element-36">
              TODO TU AÑO DE MÚSICA
              <br data-id="element-37" />
              <span className="bg-gradient-to-br from-[#F28A6F] via-[#E8623F] to-[#D8512F] bg-clip-text text-transparent" data-id="element-38">
                RESUELTO.
              </span>
            </span>
          </h1>

          <p className="hidden sm:block text-[clamp(16px,2.5vw,22px)] text-[#EADCD3] max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-39">
            MegaPack Music Pro — 12 tomos completos para docentes de Música de
            primaria y secundaria.
          </p>

          {/* Main Product Image */}
          <div className="max-w-3xl mx-auto mb-6 sm:mb-10 relative" data-id="element-40">
            <img src="https://cdn.magicpatterns.com/uploads/2r1RuJ45yRYJLBfHDbnebk/mock_musica_nuevo.png" alt="MegaPack Music Pro — Plan Anual Completo Primaria y Secundaria" width={1200} height={900} loading="eager" decoding="async"
          // @ts-ignore - fetchpriority is a valid HTML attr, not yet in some TS DOM types
          fetchpriority="high" className="w-full h-auto object-contain max-h-72 sm:max-h-[520px] mx-auto drop-shadow-[0_20px_40px_rgba(0,0,0,0.5)]" data-id="element-41" />
          </div>

          <p className="hidden sm:block text-[clamp(18px,2.5vw,24px)] font-bold text-[#FBF7F0] max-w-3xl mx-auto mb-10 leading-snug" data-id="element-42">
            +180 fichas listas para fotocopiar y usar en clase, alineadas al
            currículum argentino.
          </p>

          <div className="flex sm:hidden justify-center items-center gap-x-5 gap-y-2 flex-wrap mb-5 text-[#EADCD3] text-[14px] font-semibold" data-id="element-43">
            <span className="flex items-center gap-1.5" data-id="element-44">
              <Zap size={16} className="text-[#F28A6F]" data-id="element-45" /> 100% PDF
            </span>
            <span className="flex items-center gap-1.5" data-id="element-46">
              <Zap size={16} className="text-[#F28A6F]" data-id="element-47" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-48">🇦🇷 Currículo 2026</span>
          </div>

          <a href="#pricing" onClick={scrollToPricing} className="block sm:inline-block w-full sm:w-auto bg-gradient-to-br from-[#E8623F] to-[#D8512F] text-white px-5 py-4 sm:px-12 sm:py-5 rounded-2xl text-base sm:text-xl font-extrabold shadow-[0_20px_60px_rgba(232,98,63,0.4)] hover:-translate-y-1 hover:shadow-[0_30px_80px_rgba(232,98,63,0.5)] transition-all tracking-wide leading-tight" data-id="element-49">
            🎼 → QUIERO MI MUSIC PRO AHORA
          </a>

          <div className="flex justify-center gap-4 sm:gap-8 flex-wrap mt-5 sm:mt-8" data-id="element-50">
            <span className="text-[#EADCD3] text-[13px] flex items-center gap-1.5" data-id="element-51">
              <Shield size={14} data-id="element-52" /> Garantía 7 días
            </span>
            <span className="text-[#EADCD3] text-[13px] flex items-center gap-1.5" data-id="element-53">
              <Lock size={14} data-id="element-54" /> Pago seguro
            </span>
            <span className="text-[#EADCD3] text-[13px] flex items-center gap-1.5" data-id="element-55">
              <CreditCard size={14} data-id="element-56" /> Mercado Pago
            </span>
            <span className="hidden sm:flex text-[#EADCD3] text-[13px] items-center gap-1.5" data-id="element-57">
              <Zap size={14} data-id="element-58" /> Acceso en 5 min
            </span>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="bg-[#F5EDE3] border-y border-[#E7DDD0] py-8 px-4" data-id="element-59">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-60">
          <div data-id="element-61">
            <strong className="block text-[clamp(24px,4vw,36px)] font-black bg-gradient-to-br from-[#E8623F] to-[#D8512F] bg-clip-text text-transparent font-['Playfair_Display',serif]" data-id="element-62">
              +1.500
            </strong>
            <span className="text-[13px] text-slate-600 mt-1 block" data-id="element-63">
              Docentes en todo el país
            </span>
          </div>
          <div data-id="element-64">
            <strong className="block text-[clamp(24px,4vw,36px)] font-black bg-gradient-to-br from-[#E8623F] to-[#D8512F] bg-clip-text text-transparent font-['Playfair_Display',serif]" data-id="element-65">
              12
            </strong>
            <span className="text-[13px] text-slate-600 mt-1 block" data-id="element-66">
              Tomos listos para usar
            </span>
          </div>
          <div data-id="element-67">
            <strong className="block text-[clamp(24px,4vw,36px)] font-black bg-gradient-to-br from-[#E8623F] to-[#D8512F] bg-clip-text text-transparent font-['Playfair_Display',serif]" data-id="element-68">
              4.9/5 ⭐
            </strong>
            <span className="text-[13px] text-slate-600 mt-1 block" data-id="element-69">
              Calificación promedio
            </span>
          </div>
          <div data-id="element-70">
            <strong className="block text-[clamp(24px,4vw,36px)] font-black bg-gradient-to-br from-[#E8623F] to-[#D8512F] bg-clip-text text-transparent font-['Playfair_Display',serif]" data-id="element-71">
              🇦🇷
            </strong>
            <span className="text-[13px] text-slate-600 mt-1 block" data-id="element-72">
              Prim. y Sec. todo el país
            </span>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS TOP */}
      <section className="bg-[#FBF7F0] py-12 px-4" data-id="element-73">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-74">
          <div className="bg-white border border-[#E7DDD0] rounded-2xl p-6 shadow-sm" data-id="element-75">
            <div className="flex gap-1 mb-3" data-id="element-76">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-[#E0A93B] text-[#E0A93B]" data-id="element-77" />)}
            </div>
            <p className="text-[15px] text-slate-600 leading-relaxed mb-4 italic" data-id="element-78">
              "En una sola tarde dejé planificado todo el ciclo lectivo de
              Música. Me ahorró meses de trabajo."
            </p>
            <div className="flex items-center gap-3" data-id="element-79">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E8623F] to-[#D8512F] flex items-center justify-center text-white font-bold text-sm flex-shrink-0" data-id="element-80">
                SF
              </div>
              <div data-id="element-81">
                <strong className="block text-sm text-[#2B2330] font-bold" data-id="element-82">
                  Sofía F.
                </strong>
                <span className="text-xs text-slate-500" data-id="element-83">
                  📍 Córdoba | Docente de Música Primaria
                </span>
              </div>
            </div>
          </div>
          <div className="bg-white border border-[#E7DDD0] rounded-2xl p-6 shadow-sm" data-id="element-84">
            <div className="flex gap-1 mb-3" data-id="element-85">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-[#E0A93B] text-[#E0A93B]" data-id="element-86" />)}
            </div>
            <p className="text-[15px] text-slate-600 leading-relaxed mb-4 italic" data-id="element-87">
              "Mis chicos de secundaria pasaron de la indiferencia total a
              pedirme la próxima clase. Las fichas los atrapan."
            </p>
            <div className="flex items-center gap-3" data-id="element-88">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E8623F] to-[#D8512F] flex items-center justify-center text-white font-bold text-sm flex-shrink-0" data-id="element-89">
                VA
              </div>
              <div data-id="element-90">
                <strong className="block text-sm text-[#2B2330] font-bold" data-id="element-91">
                  Valeria A.
                </strong>
                <span className="text-xs text-slate-500" data-id="element-92">
                  📍 Rosario | Docente de Música Secundaria
                </span>
              </div>
            </div>
          </div>
          <div className="bg-white border border-[#E7DDD0] rounded-2xl p-6 shadow-sm" data-id="element-93">
            <div className="flex gap-1 mb-3" data-id="element-94">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-[#E0A93B] text-[#E0A93B]" data-id="element-95" />)}
            </div>
            <p className="text-[15px] text-slate-600 leading-relaxed mb-4 italic" data-id="element-96">
              "Llego a cada clase con todo resuelto y con seguridad. Mi año dejó
              de ser una improvisación constante."
            </p>
            <div className="flex items-center gap-3" data-id="element-97">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E8623F] to-[#D8512F] flex items-center justify-center text-white font-bold text-sm flex-shrink-0" data-id="element-98">
                EN
              </div>
              <div data-id="element-99">
                <strong className="block text-sm text-[#2B2330] font-bold" data-id="element-100">
                  Ezequiel N.
                </strong>
                <span className="text-xs text-slate-500" data-id="element-101">
                  📍 Buenos Aires | Docente Prim. y Sec.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PAIN SECTION */}
      <section className="bg-[#F5EDE3] py-20 px-4 text-center" data-id="element-102">
        <div className="inline-block bg-[#E8623F]/10 border border-[#E8623F]/20 text-[#E8623F] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide uppercase mb-6" data-id="element-103">
          ¿Te suena familiar?
        </div>
        <h2 className="text-[clamp(24px,4vw,42px)] font-black mb-4 leading-[1.2] font-['Playfair_Display',serif] text-[#2B2330]" data-id="element-104">
          Si sos docente de Música,
          <br data-id="element-105" />
          esto te va a sonar familiar
        </h2>
        <p className="text-lg text-slate-600 mb-12 max-w-2xl mx-auto" data-id="element-106">
          Domingos perdidos y clases improvisadas.
        </p>

        <div className="max-w-2xl mx-auto mb-12 text-left flex flex-col gap-4" data-id="element-107">
          <div className="flex items-start gap-4 bg-white border border-[#E7DDD0] rounded-xl p-5 shadow-sm" data-id="element-108">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-109">😰</span>
            <p className="text-base text-slate-600 leading-relaxed" data-id="element-110">
              Domingo a la noche buscando actividades que nunca quedan como
              querés para el lunes
            </p>
          </div>
          <div className="flex items-start gap-4 bg-white border border-[#E7DDD0] rounded-xl p-5 shadow-sm" data-id="element-111">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-112">📋</span>
            <p className="text-base text-slate-600 leading-relaxed" data-id="element-113">
              Clases improvisadas porque no tenés fichas listas y secuenciadas
              para cada grado
            </p>
          </div>
          <div className="flex items-start gap-4 bg-white border border-[#E7DDD0] rounded-xl p-5 shadow-sm" data-id="element-114">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-115">😴</span>
            <p className="text-base text-slate-600 leading-relaxed" data-id="element-116">
              Alumnos que no se enganchan porque el material es genérico y no
              fue pensado para ellos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-white border border-[#E7DDD0] rounded-xl p-5 shadow-sm" data-id="element-117">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-118">⏰</span>
            <p className="text-base text-slate-600 leading-relaxed" data-id="element-119">
              Horas perdidas buscando fichas de ritmo, lectoescritura o folclore
              que sirvan de verdad
            </p>
          </div>
          <div className="flex items-start gap-4 bg-white border border-[#E7DDD0] rounded-xl p-5 shadow-sm" data-id="element-120">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-121">📝</span>
            <p className="text-base text-slate-600 leading-relaxed" data-id="element-122">
              Planificaciones hechas de apuro que el directivo igual te devuelve
              para corregir
            </p>
          </div>
          <div className="flex items-start gap-4 bg-white border border-[#E7DDD0] rounded-xl p-5 shadow-sm" data-id="element-123">
            <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-124">🎭</span>
            <p className="text-base text-slate-600 leading-relaxed" data-id="element-125">
              Los actos escolares que te roban semanas de clase y te agotan sin
              reconocimiento
            </p>
          </div>
        </div>

        <p className="text-[clamp(20px,3vw,32px)] font-extrabold text-[#2B2330] max-w-2xl mx-auto mb-10 font-['Playfair_Display',serif]" data-id="element-126">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Extra Persuasive CTA */}
        <button onClick={scrollToPricing} className="inline-block bg-[#E8623F] text-white px-8 py-4 rounded-xl text-lg font-extrabold shadow-[0_10px_40px_rgba(232,98,63,0.3)] hover:-translate-y-1 hover:shadow-[0_15px_50px_rgba(232,98,63,0.4)] transition-all tracking-wide" data-id="element-127">
          👉 ES HORA DE RECUPERAR TUS DOMINGOS
        </button>
      </section>

      {/* PRODUCT SECTION */}
      <section className="bg-[#FBF7F0] py-20 px-4 text-center" data-id="element-128">
        <div className="max-w-6xl mx-auto" data-id="element-129">
          <div className="inline-block bg-[#E8623F]/10 border border-[#E8623F]/20 text-[#E8623F] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide uppercase mb-6" data-id="element-130">
            🎵 Music Pro
          </div>
          <h2 className="text-[clamp(24px,4vw,42px)] font-black mb-4 leading-[1.2] font-['Playfair_Display',serif] text-[#2B2330]" data-id="element-131">
            El sistema N°1 para docentes
            <br data-id="element-132" />
            de Música en Argentina
          </h2>
          <p className="text-lg text-slate-600 mb-12" data-id="element-133">
            MEGAPACK MUSIC PRO — 180 fichas listas para usar desde hoy
          </p>

          <div className="flex justify-center gap-2 flex-wrap my-10" data-id="element-134">
            {[1, 2, 3, 4, 5, 6].map(n => <div key={`p-${n}`} className="px-5 py-2.5 rounded-full text-[15px] font-bold bg-[#E8623F]/10 border border-[#E8623F]/30 text-[#E8623F]" data-id="element-135">
                {n}°
              </div>)}
            <div className="w-0.5 bg-[#E7DDD0] mx-2" data-id="element-136"></div>
            {[1, 2, 3, 4, 5, 6].map(n => <div key={`s-${n}`} className="px-5 py-2.5 rounded-full text-[15px] font-bold bg-[#E8623F]/10 border border-[#E8623F]/30 text-[#E8623F]" data-id="element-137">
                {n}°
              </div>)}
          </div>

          <div className="flex justify-center gap-6 mb-12 flex-wrap" data-id="element-138">
            <span className="text-[13px] text-[#E8623F] font-bold" data-id="element-139">
              ← PRIMARIA
            </span>
            <span className="text-[13px] text-[#E8623F] font-bold" data-id="element-140">
              SECUNDARIA →
            </span>
          </div>

          {/* PRIMARIA */}
          <div className="mb-12" data-id="element-141">
            <div className="text-xl font-extrabold text-[#2B2330] text-center mb-6 pb-4 border-b border-[#E7DDD0] font-['Playfair_Display',serif]" data-id="element-142">
              🎵 PRIMARIA — 6 TOMOS
            </div>
            <p className="text-sm text-slate-600 mb-7 text-center" data-id="element-143">
              Para docentes de Música de 1° a 6° grado
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-left" data-id="element-144">
              {[{
              n: 1,
              title: 'Tomo 1 — 1° Grado',
              sub: 'Sonidos, Cuerpo y Entorno',
              desc: 'Entorno sonoro, sonido/silencio, duración, pulso, percusión corporal y cotidiáfonos.'
            }, {
              n: 2,
              title: 'Tomo 2 — 2° Grado',
              sub: 'Pulso, Ritmo y Timbre',
              desc: 'Pulso, acento, patrón rítmico, timbre y grafía convencional inicial.'
            }, {
              n: 3,
              title: 'Tomo 3 — 3° Grado',
              sub: 'Melodía y Forma Musical',
              desc: 'Melodía, frase, estrofa, escala y primeras figuras rítmicas convencionales.'
            }, {
              n: 4,
              title: 'Tomo 4 — 4° Grado',
              sub: 'Lectoescritura y Folclore',
              desc: 'Pentagrama, clave de Sol, negra y corchea. Folclore argentino integrado.'
            }, {
              n: 5,
              title: 'Tomo 5 — 5° Grado',
              sub: 'Armonía y Géneros',
              desc: 'Acorde, consonancia, géneros musicales y músicas del mundo.'
            }, {
              n: 6,
              title: 'Tomo 6 — 6° Grado',
              sub: 'Producción y Contexto',
              desc: 'Composición, arreglo, historia de la música y producción grupal.'
            }].map(tomo => <div key={tomo.n} className="bg-white border border-[#E7DDD0] rounded-2xl p-6 flex gap-4 items-start hover:border-[#E8623F] hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(232,98,63,0.15)] transition-all shadow-sm" data-id="element-145">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#E8623F] to-[#D8512F] flex items-center justify-center font-black text-lg text-white flex-shrink-0" data-id="element-146">
                    {tomo.n}
                  </div>
                  <div data-id="element-147">
                    <strong className="block text-[15px] font-extrabold text-[#2B2330] mb-1" data-id="element-148">
                      {tomo.title}
                    </strong>
                    <div className="text-[13px] text-[#E8623F] font-semibold mb-1.5" data-id="element-149">
                      {tomo.sub}
                    </div>
                    <p className="text-[13px] text-slate-600 leading-relaxed" data-id="element-150">
                      {tomo.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* SECUNDARIA */}
          <div className="mb-12" data-id="element-151">
            <div className="text-xl font-extrabold text-[#2B2330] text-center mb-6 pb-4 border-b border-[#E7DDD0] font-['Playfair_Display',serif]" data-id="element-152">
              🎓 SECUNDARIA — 6 TOMOS
            </div>
            <p className="text-sm text-slate-600 mb-7 text-center" data-id="element-153">
              Para docentes de Música de 1° a 6° año
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-left" data-id="element-154">
              {[{
              n: 7,
              title: 'Tomo 7 — 1° Año',
              sub: 'El Lenguaje del Sonido',
              desc: 'Parámetros del sonido, lectoescritura básica y géneros populares argentinos.'
            }, {
              n: 8,
              title: 'Tomo 8 — 2° Año',
              sub: 'Ritmo, Forma y Cultura',
              desc: 'Ritmo en contexto, forma musical y músicas del Río de la Plata.'
            }, {
              n: 9,
              title: 'Tomo 9 — 3° Año',
              sub: 'Armonía y Producción',
              desc: 'Acordes, progresiones, análisis de canciones y producción musical básica.'
            }, {
              n: 10,
              title: 'Tomo 10 — 4° Año',
              sub: 'Música y Sociedad',
              desc: 'Industria musical, derechos de autor, música y medios de comunicación.'
            }, {
              n: 11,
              title: 'Tomo 11 — 5° Año',
              sub: 'Análisis y Composición',
              desc: 'Análisis musical profundo, composición con criterio y producción digital.'
            }, {
              n: 12,
              title: 'Tomo 12 — 6° Año',
              sub: 'Proyecto Musical Final',
              desc: 'Proyecto integrador, identidad musical y música para el mundo real.'
            }].map(tomo => <div key={tomo.n} className="bg-white border border-[#E7DDD0] rounded-2xl p-6 flex gap-4 items-start hover:border-[#E8623F] hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(232,98,63,0.15)] transition-all shadow-sm" data-id="element-155">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#E8623F] to-[#D8512F] flex items-center justify-center font-black text-lg text-white flex-shrink-0" data-id="element-156">
                    {tomo.n}
                  </div>
                  <div data-id="element-157">
                    <strong className="block text-[15px] font-extrabold text-[#2B2330] mb-1" data-id="element-158">
                      {tomo.title}
                    </strong>
                    <div className="text-[13px] text-[#E8623F] font-semibold mb-1.5" data-id="element-159">
                      {tomo.sub}
                    </div>
                    <p className="text-[13px] text-slate-600 leading-relaxed" data-id="element-160">
                      {tomo.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* INCLUDES */}
          <div className="bg-white border border-[#E7DDD0] rounded-3xl p-8 sm:p-10 text-left mt-12 shadow-sm" data-id="element-161">
            <h3 className="text-xl font-extrabold text-[#2B2330] mb-6 text-center font-['Playfair_Display',serif]" data-id="element-162">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-163">
              {['15 fichas listas para imprimir y entregar', 'Consignas claras que el alumno entiende solo', 'Diseño en blanco y negro para fotocopiadora', 'Solucionario para corrección rápida', 'Guía docente de uso express', 'Alineado al currículum argentino vigente', 'Folclore y música actual integrados', 'Secuencia didáctica con evaluación incluida'].map((item, i) => <div key={i} className="flex items-center gap-3 text-slate-600 text-sm font-semibold" data-id="element-164">
                  <div className="w-6 h-6 bg-[#E8623F]/10 border border-[#E8623F]/30 rounded-md flex items-center justify-center text-xs text-[#E8623F] flex-shrink-0" data-id="element-165">
                    ✓
                  </div>
                  {item}
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* BONUS SECTION */}
      <section className="bg-[#F5EDE3] py-20 px-4" data-id="element-166">
        <div className="max-w-5xl mx-auto text-center" data-id="element-167">
          <div className="inline-block bg-[#E8623F]/10 border border-[#E8623F]/20 text-[#E8623F] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide uppercase mb-6" data-id="element-168">
            Regalos estratégicos
          </div>
          <h2 className="text-[clamp(24px,4vw,42px)] font-black mb-4 leading-[1.2] font-['Playfair_Display',serif] text-[#2B2330]" data-id="element-169">
            Más los 6 Bonus
            <br data-id="element-170" />
            <span className="bg-gradient-to-br from-[#E8623F] to-[#D8512F] bg-clip-text text-transparent" data-id="element-171">
              Incluidos en todas las ofertas
            </span>
          </h2>
          <p className="text-lg text-slate-600 mb-12" data-id="element-172">
            Sin costo extra. Incluidos desde el primer día.{' '}
            <span className="text-[#2E7D32] font-bold" data-id="element-173">
              GRATIS POR EL DÍA DE HOY.
            </span>
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 text-left" data-id="element-174">
            {[{
            n: '01',
            title: 'Planilla Maestra de Notas',
            tag: '"200 alumnos en 15 minutos semanales"',
            desc: 'Sistema de registro con semáforo automático para detectar alumnos en riesgo antes de que sea tarde. Promedios automáticos y banco de frases para el boletín.',
            val: '$12.000',
            img: 'https://cdn.magicpatterns.com/uploads/f96NXFPhdPWuRmGTdrVy31/105.png'
          }, {
            n: '02',
            title: 'Pack Organización Semanal Docente',
            tag: '"Domingo Sin Caos"',
            desc: 'Rutina de 20 minutos para ordenar toda la semana antes de que empiece. Planificador semanal, checklist del bolso y tracker de pendientes por escuela.',
            val: '$10.000',
            img: 'https://cdn.magicpatterns.com/uploads/8FF75AERwGU4qWfJLwTRAA/106.png'
          }, {
            n: '03',
            title: 'Kit de Actos y Efemérides',
            tag: '"10 fechas patrias resueltas"',
            desc: 'Glosas listas para usar, canciones sugeridas, plan de 2 ensayos y puestas en escena de alto impacto para cada fecha del calendario escolar argentino.',
            val: '$9.000',
            img: 'https://cdn.magicpatterns.com/uploads/uy6vRbESnYTfhwhaWyKc6n/107.png'
          }, {
            n: '04',
            title: 'Clases Salvavidas',
            tag: '"Para cuando todo falla"',
            desc: '8 clases de emergencia completas para usar sin preparación. Sin internet, sin parlante, con el aula en caos o con solo 10 minutos de clase: siempre tenés un plan.',
            val: '$8.000',
            img: 'https://cdn.magicpatterns.com/uploads/r7YM2t2YTjTGRiE6KMM6sS/108.png'
          }, {
            n: '05',
            title: 'Materiales Cero Presupuesto',
            tag: '"Música de calidad con lo que ya tenés"',
            desc: '6 instrumentos construibles con materiales de descarte, la Orquesta de Reciclaje completa y fundamentación lista para presentar al directivo con eje EAI.',
            val: '$7.000',
            img: 'https://cdn.magicpatterns.com/uploads/op2b7MzuKy6ueWUbGHgGeV/109.png'
          }, {
            n: '06',
            title: 'Banco de Cancioneros y Partituras',
            tag: '"Hits actuales + Folclore argentino"',
            desc: '10 canciones con melodía simplificada, cifrado de guitarra, actividad pedagógica y conexión con los NAP. Organizadas por nivel y contenido.',
            val: '$9.000',
            img: 'https://cdn.magicpatterns.com/uploads/mMDexYAPhCSnBqLuQEXSrG/110.png'
          }].map((b, i) => <div key={i} className="bg-white border border-[#E7DDD0] rounded-2xl overflow-hidden hover:border-[#E8623F] hover:-translate-y-1 transition-all flex flex-col shadow-sm" data-id="element-175">
                <img src={b.img} alt={b.title} loading="lazy" decoding="async" className="w-full h-64 object-contain bg-[#FBF7F0] border-b border-[#E7DDD0] p-2" data-id="element-176" />
                <div className="p-6 flex-1 flex flex-col" data-id="element-177">
                  <div className="inline-block bg-gradient-to-br from-[#E8623F] to-[#D8512F] text-white px-3 py-1 rounded-full text-[11px] font-extrabold tracking-wide uppercase mb-4 self-start" data-id="element-178">
                    Bonus {b.n}
                  </div>
                  <h4 className="text-[17px] font-extrabold text-[#2B2330] mb-2 leading-[1.3] font-['Playfair_Display',serif]" data-id="element-179">
                    {b.title}
                  </h4>
                  <span className="text-xs text-[#E8623F] font-bold italic mb-3 block" data-id="element-180">
                    {b.tag}
                  </span>
                  <p className="text-sm text-slate-600 leading-relaxed mb-4 flex-1" data-id="element-181">
                    {b.desc}
                  </p>
                  <div className="flex items-center justify-between mt-auto pt-4 border-t border-[#E7DDD0]" data-id="element-182">
                    <span className="text-[13px] text-slate-500 line-through" data-id="element-183">
                      Valor {b.val}
                    </span>
                    <span className="bg-[#2E7D32]/10 border border-[#2E7D32]/20 text-[#2E7D32] px-3 py-1 rounded-full text-xs font-extrabold uppercase tracking-wide" data-id="element-184">
                      → GRATIS
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* TIMER */}
      <section className="bg-gradient-to-br from-[#4A233E] to-[#3E1B38] py-16 px-4 text-center border-y border-[#703B5D]" data-id="element-185">
        <p className="text-sm text-[#EADCD3] uppercase tracking-widest font-bold mb-6" data-id="element-186">
          ⏰ El precio de lanzamiento termina en:
        </p>

        <div className="mb-8" data-id="element-187">
          <CountdownTimer hours={23} minutes={55} seconds={51} data-id="element-188" />
        </div>

        <div className="max-w-lg mx-auto mb-6" data-id="element-189">
          <div className="flex justify-between text-[13px] text-[#EADCD3] mb-2 font-semibold" data-id="element-190">
            <span data-id="element-191">Cupos al precio de lanzamiento</span>
            <span data-id="element-192">68% tomados</span>
          </div>
          <div className="bg-[#703B5D] rounded-full h-3 overflow-hidden" data-id="element-193">
            <div className="bg-gradient-to-br from-[#E8623F] to-[#D8512F] h-full w-[68%] rounded-full animate-[glow_2s_ease-in-out_infinite] shadow-[0_0_8px_rgba(232,98,63,0.5)]" data-id="element-194"></div>
          </div>
          <p className="text-sm text-[#EADCD3] mt-2 font-semibold" data-id="element-195">
            Después sube $10.000 ARS y no vuelve a bajar
          </p>
        </div>

        <button onClick={scrollToPricing} className="inline-block bg-gradient-to-br from-[#E8623F] to-[#D8512F] text-white px-8 py-4 rounded-xl text-lg font-extrabold shadow-[0_20px_60px_rgba(232,98,63,0.4)] hover:-translate-y-1 hover:shadow-[0_30px_80px_rgba(232,98,63,0.5)] transition-all tracking-wide" data-id="element-196">
          → ASEGURAR MI PRECIO AHORA
        </button>
      </section>

      {/* PRICING */}
      <section id="pricing" className="bg-[#FBF7F0] py-8 sm:py-20 px-4 text-center scroll-mt-2 sm:scroll-mt-10" data-id="element-197">
        <div className="max-w-6xl mx-auto" data-id="element-198">
          <div className="hidden sm:inline-block bg-[#E8623F]/10 border border-[#E8623F]/20 text-[#E8623F] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide uppercase mb-6" data-id="element-199">
            Elegí tu pack
          </div>
          <h2 className="hidden sm:block text-[clamp(24px,4vw,42px)] font-black mb-12 leading-[1.2] font-['Playfair_Display',serif] text-[#2B2330]" data-id="element-200">
            Todas las opciones incluyen
            <br data-id="element-201" />
            los 6 bonus estratégicos
          </h2>
          <h2 className="sm:hidden text-[28px] font-black text-[#2B2330] mb-2 leading-tight text-left font-['Playfair_Display',serif]" data-id="element-202">
            Elegí tu Music Pro:
          </h2>
          <p className="sm:hidden text-[15px] text-slate-600 mb-6 leading-snug text-left" data-id="element-203">
            Todas las opciones incluyen los 6 bonus estratégicos
          </p>

          <div className="flex flex-col gap-3 sm:gap-8 items-stretch max-w-xl mx-auto" data-id="element-204">
            {/* PRIMARIA */}
            <div className={`bg-white border rounded-xl sm:rounded-3xl p-4 sm:p-9 text-left hover:-translate-y-1 transition-all ${selectedPack === 'primaria' ? 'border-[#E8623F] sm:border-[#E7DDD0] shadow-[0_0_30px_rgba(232,98,63,0.15)] sm:shadow-sm' : 'border-[#E7DDD0] shadow-sm'}`} data-id="element-205">
              <button type="button" onClick={() => handleSelectPack('primaria')} className="flex sm:hidden items-center gap-3 w-full text-left" data-id="element-206">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${selectedPack === 'primaria' ? 'border-[#E8623F]' : 'border-[#E7DDD0]'}`} data-id="element-207">
                  {selectedPack === 'primaria' && <div className="w-2.5 h-2.5 rounded-full bg-[#E8623F]" data-id="element-208"></div>}
                </div>
                <div className="text-2xl flex-shrink-0" data-id="element-209">📘</div>
                <div className="flex-1 min-w-0" data-id="element-210">
                  <div className="text-lg font-extrabold text-[#2B2330] leading-tight uppercase tracking-tight font-['Playfair_Display',serif]" data-id="element-211">
                    Primaria
                  </div>
                  <div className="text-[13px] text-slate-600 leading-snug mt-1" data-id="element-212">
                    6 tomos + 90 fichas + 6 bonus
                  </div>
                </div>
                <div className="flex-shrink-0 text-right" data-id="element-213">
                  <div className="text-[12px] text-slate-500 line-through leading-none mb-1" data-id="element-214">
                    $49.990
                  </div>
                  <div className="text-[22px] font-black text-[#2B2330] leading-none" data-id="element-215">
                    $16.990
                  </div>
                </div>
              </button>
              <div className="hidden sm:block text-3xl mb-4" data-id="element-216">📘</div>
              <div className="hidden sm:block text-[22px] font-black text-[#2B2330] mb-2 font-['Playfair_Display',serif]" data-id="element-217">
                Primaria
              </div>
              <div className="hidden sm:block text-sm text-slate-600 mb-6 leading-relaxed" data-id="element-218">
                6 tomos + 90 fichas + 6 bonus estratégicos
              </div>
              <div className="hidden sm:block text-base text-slate-500 line-through mb-1" data-id="element-219">
                $49.990
              </div>
              <div className="hidden sm:block text-[clamp(32px,5vw,48px)] font-black text-[#2B2330] mb-1 leading-none" data-id="element-220">
                $16.990{' '}
                <span className="text-xl font-bold text-slate-500" data-id="element-221">ARS</span>
              </div>
              <div className="hidden sm:block text-sm text-slate-600 mb-7" data-id="element-222">
                Pago único — Acceso de por vida
              </div>

              <ul className="hidden sm:flex flex-col gap-3 mb-8" data-id="element-223">
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-224">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-225">
                    ✓
                  </span>
                  6 tomos (1° a 6° grado)
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-226">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-227">
                    ✓
                  </span>
                  90 fichas listas para imprimir
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-228">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-229">
                    ✓
                  </span>
                  Solucionarios incluidos
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-230">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-231">
                    ✓
                  </span>
                  6 bonus estratégicos completos
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-232">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-233">
                    ✓
                  </span>
                  Acceso inmediato en PDF
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-234">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-235">
                    ✓
                  </span>
                  Actualizaciones gratuitas
                </li>
              </ul>
              <a href="https://docente360.com.ar/checkouts/cn/hWNEGH7mVaBI7epFoEC6NV3a/en-ar?_r=AQABJgCMGBwljeh1XwBmny70H1EovkBbXYcMchBbkSlerjA" target="_blank" rel="noopener noreferrer" onClick={() => handleCheckoutClick('primaria')} className="hidden sm:block w-full text-center py-4 px-6 rounded-xl text-base font-extrabold bg-[#F5EDE3] text-[#2B2330] border border-[#E7DDD0] hover:bg-[#E7DDD0] transition-colors tracking-wide" data-id="element-236">
                → QUIERO PRIMARIA
              </a>
            </div>

            {/* PACK COMPLETO */}
            <div className="bg-gradient-to-br from-[#5B2A4E] to-[#3E1B38] border-2 border-[#C9971F] rounded-xl sm:rounded-3xl p-4 sm:p-9 text-left relative shadow-[0_0_60px_rgba(201,151,31,0.25)] hover:-translate-y-1 transition-transform z-10" data-id="element-237">
              <div className="hidden sm:block absolute -top-3.5 left-1/2 -translate-x-1/2 bg-gradient-to-br from-[#E0A93B] to-[#C9971F] text-white px-5 py-1.5 rounded-full text-xs font-extrabold whitespace-nowrap tracking-wide" data-id="element-238">
                ⭐ MÁS ELEGIDO — AHORRÁS $7.990
              </div>
              <button type="button" onClick={() => handleSelectPack('completo')} className="flex sm:hidden items-center gap-3 w-full text-left" data-id="element-239">
                <div className="w-5 h-5 rounded-full border-2 border-[#C9971F] flex items-center justify-center flex-shrink-0" data-id="element-240">
                  {selectedPack === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-[#C9971F]" data-id="element-241"></div>}
                </div>
                <div className="text-2xl flex-shrink-0" data-id="element-242">🏆</div>
                <div className="flex-1 min-w-0" data-id="element-243">
                  <div className="text-lg font-extrabold text-[#FBF7F0] leading-tight uppercase tracking-tight font-['Playfair_Display',serif]" data-id="element-244">
                    Pack Completo
                  </div>
                  <div className="flex flex-wrap gap-1.5 mt-1.5" data-id="element-245">
                    <span className="bg-gradient-to-br from-[#E0A93B] to-[#C9971F] text-white text-[10px] font-extrabold px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-246">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-green-500/20 border border-green-500/40 text-green-300 text-[10px] font-extrabold px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-247">
                      AHORRÁS $7.990
                    </span>
                  </div>
                  <div className="text-[13px] text-[#EADCD3] leading-snug mt-2" data-id="element-248">
                    12 tomos + 180 fichas + 6 bonus + 2 Ebooks Elite
                  </div>
                </div>
                <div className="flex-shrink-0 text-right" data-id="element-249">
                  <div className="text-[12px] text-[#EADCD3]/70 line-through leading-none mb-1" data-id="element-250">
                    $99.980
                  </div>
                  <div className="text-[22px] font-black bg-gradient-to-br from-[#E0A93B] to-[#C9971F] bg-clip-text text-transparent leading-none" data-id="element-251">
                    $27.990
                  </div>
                </div>
              </button>
              <div className="hidden sm:block text-3xl mb-4 mt-2" data-id="element-252">🏆</div>
              <div className="hidden sm:block text-[22px] font-black text-[#FBF7F0] mb-2 font-['Playfair_Display',serif]" data-id="element-253">
                Pack Completo
              </div>
              <div className="hidden sm:block text-sm text-[#EADCD3] mb-4 leading-relaxed" data-id="element-254">
                Todo el sistema para docentes que enseñan en los dos niveles
              </div>
              <div className="hidden sm:inline-block bg-green-500/15 border border-green-500/30 text-green-400 px-3 py-1 rounded-full text-xs font-extrabold mb-5" data-id="element-255">
                AHORRÁS $7.990 vs comprar por separado
              </div>

              <div className="hidden sm:block text-base text-[#EADCD3]/70 line-through mb-1" data-id="element-256">
                $99.980
              </div>
              <div className="hidden sm:block text-[clamp(32px,5vw,48px)] font-black text-[#FBF7F0] mb-1 leading-none" data-id="element-257">
                $27.990{' '}
                <span className="text-xl font-bold text-[#EADCD3]" data-id="element-258">ARS</span>
              </div>
              <div className="hidden sm:block text-sm text-[#EADCD3] mb-7" data-id="element-259">
                Pago único — Acceso de por vida
              </div>

              <ul className="hidden sm:flex flex-col gap-3 mb-8" data-id="element-260">
                <li className="flex items-start gap-2.5 text-sm text-[#EADCD3] leading-snug" data-id="element-261">
                  <span className="text-[#E0A93B] font-black flex-shrink-0 mt-px" data-id="element-262">
                    ✓
                  </span>
                  12 tomos completos (Prim. + Sec.)
                </li>
                <li className="flex items-start gap-2.5 text-sm text-[#EADCD3] leading-snug" data-id="element-263">
                  <span className="text-[#E0A93B] font-black flex-shrink-0 mt-px" data-id="element-264">
                    ✓
                  </span>
                  180 fichas listas para imprimir
                </li>
                <li className="flex items-start gap-2.5 text-sm text-[#EADCD3] leading-snug" data-id="element-265">
                  <span className="text-[#E0A93B] font-black flex-shrink-0 mt-px" data-id="element-266">
                    ✓
                  </span>
                  Solucionarios incluidos
                </li>
                <li className="flex items-start gap-2.5 text-sm text-[#EADCD3] leading-snug" data-id="element-267">
                  <span className="text-[#E0A93B] font-black flex-shrink-0 mt-px" data-id="element-268">
                    ✓
                  </span>
                  6 bonus estratégicos completos
                </li>
                <li className="flex items-start gap-2.5 text-sm text-[#EADCD3] leading-snug" data-id="element-269">
                  <span className="text-[#E0A93B] font-black flex-shrink-0 mt-px" data-id="element-270">
                    ✓
                  </span>
                  Acceso inmediato en PDF
                </li>
                <li className="flex items-start gap-2.5 text-sm text-[#E0A93B] font-bold leading-snug" data-id="element-271">
                  <span className="text-[#E0A93B] font-black flex-shrink-0 mt-px" data-id="element-272">
                    ✓
                  </span>
                  ⭐ Ebook Elite: Actos Escolares de Autor (20 págs)
                </li>
                <li className="flex items-start gap-2.5 text-sm text-[#E0A93B] font-bold leading-snug" data-id="element-273">
                  <span className="text-[#E0A93B] font-black flex-shrink-0 mt-px" data-id="element-274">
                    ✓
                  </span>
                  ⭐ Ebook Elite: Proyectos ESI + EAI (20 págs)
                </li>
                <li className="flex items-start gap-2.5 text-sm text-[#EADCD3] leading-snug" data-id="element-275">
                  <span className="text-[#E0A93B] font-black flex-shrink-0 mt-px" data-id="element-276">
                    ✓
                  </span>
                  Actualizaciones gratuitas de por vida
                </li>
              </ul>
              <a href="https://docente360.com.ar/checkouts/cn/hWNEGH8A7rrbt6sXBIIhxzlK/en-ar?_r=AQABU4dTxDRR5QCw-i4Ora25l45Gf5XNKEZnaGUJ1FdZJYw" target="_blank" rel="noopener noreferrer" onClick={() => handleCheckoutClick('completo')} className="hidden sm:block w-full text-center py-4 px-6 rounded-xl text-base font-extrabold bg-gradient-to-br from-[#E8623F] to-[#D8512F] text-white hover:shadow-[0_20px_60px_rgba(232,98,63,0.6)] hover:-translate-y-0.5 transition-all tracking-wide animate-[ctaPulse_1.3s_ease-in-out_infinite]" data-id="element-277">
                → SÍ, QUIERO EL PACK COMPLETO
              </a>
            </div>

            {/* SECUNDARIA */}
            <div className={`bg-white border rounded-xl sm:rounded-3xl p-4 sm:p-9 text-left hover:-translate-y-1 transition-all ${selectedPack === 'secundaria' ? 'border-[#E8623F] sm:border-[#E7DDD0] shadow-[0_0_30px_rgba(232,98,63,0.15)] sm:shadow-sm' : 'border-[#E7DDD0] shadow-sm'}`} data-id="element-278">
              <button type="button" onClick={() => handleSelectPack('secundaria')} className="flex sm:hidden items-center gap-3 w-full text-left" data-id="element-279">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${selectedPack === 'secundaria' ? 'border-[#E8623F]' : 'border-[#E7DDD0]'}`} data-id="element-280">
                  {selectedPack === 'secundaria' && <div className="w-2.5 h-2.5 rounded-full bg-[#E8623F]" data-id="element-281"></div>}
                </div>
                <div className="text-2xl flex-shrink-0" data-id="element-282">📗</div>
                <div className="flex-1 min-w-0" data-id="element-283">
                  <div className="text-lg font-extrabold text-[#2B2330] leading-tight uppercase tracking-tight font-['Playfair_Display',serif]" data-id="element-284">
                    Secundaria
                  </div>
                  <div className="text-[13px] text-slate-600 leading-snug mt-1" data-id="element-285">
                    6 tomos + 90 fichas + 6 bonus
                  </div>
                </div>
                <div className="flex-shrink-0 text-right" data-id="element-286">
                  <div className="text-[12px] text-slate-500 line-through leading-none mb-1" data-id="element-287">
                    $49.990
                  </div>
                  <div className="text-[22px] font-black text-[#2B2330] leading-none" data-id="element-288">
                    $18.990
                  </div>
                </div>
              </button>
              <div className="hidden sm:block text-3xl mb-4" data-id="element-289">📗</div>
              <div className="hidden sm:block text-[22px] font-black text-[#2B2330] mb-2 font-['Playfair_Display',serif]" data-id="element-290">
                Secundaria
              </div>
              <div className="hidden sm:block text-sm text-slate-600 mb-6 leading-relaxed" data-id="element-291">
                6 tomos + 90 fichas + 6 bonus estratégicos
              </div>
              <div className="hidden sm:block text-base text-slate-500 line-through mb-1" data-id="element-292">
                $49.990
              </div>
              <div className="hidden sm:block text-[clamp(32px,5vw,48px)] font-black text-[#2B2330] mb-1 leading-none" data-id="element-293">
                $18.990{' '}
                <span className="text-xl font-bold text-slate-500" data-id="element-294">ARS</span>
              </div>
              <div className="hidden sm:block text-sm text-slate-600 mb-7" data-id="element-295">
                Pago único — Acceso de por vida
              </div>

              <ul className="hidden sm:flex flex-col gap-3 mb-8" data-id="element-296">
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-297">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-298">
                    ✓
                  </span>
                  6 tomos (1° a 6° año)
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-299">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-300">
                    ✓
                  </span>
                  90 fichas listas para imprimir
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-301">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-302">
                    ✓
                  </span>
                  Solucionarios incluidos
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-303">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-304">
                    ✓
                  </span>
                  6 bonus estratégicos completos
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-305">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-306">
                    ✓
                  </span>
                  Acceso inmediato en PDF
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-600 leading-snug" data-id="element-307">
                  <span className="text-[#E8623F] font-black flex-shrink-0 mt-px" data-id="element-308">
                    ✓
                  </span>
                  Actualizaciones gratuitas
                </li>
              </ul>
              <a href="https://docente360.com.ar/checkouts/cn/hWNEGH7yrWvuSdeLd7wxmIhW/en-ar?_r=AQABorVlwvaR7yNKHn1W-1vLawo7ZtDh_s1JENB8fp0qwN0" target="_blank" rel="noopener noreferrer" onClick={() => handleCheckoutClick('secundaria')} className="hidden sm:block w-full text-center py-4 px-6 rounded-xl text-base font-extrabold bg-[#F5EDE3] text-[#2B2330] border border-[#E7DDD0] hover:bg-[#E7DDD0] transition-colors tracking-wide" data-id="element-309">
                → QUIERO SECUNDARIA
              </a>
            </div>
            <div className="sm:hidden mt-6 pt-6 border-t border-[#E7DDD0] flex flex-col gap-3 items-stretch" data-id="element-310">
              <a href={checkoutUrls[selectedPack]} target="_blank" rel="noopener noreferrer" onClick={() => handleCheckoutClick(selectedPack)} className="block w-full text-center py-4 px-6 rounded-xl text-base font-extrabold bg-gradient-to-br from-[#E8623F] to-[#D8512F] text-white tracking-wide animate-[ctaPulse_1.3s_ease-in-out_infinite]" data-id="element-311">
                {packLabels[selectedPack]} →
              </a>
              <p className="text-[13px] text-slate-600 italic text-center px-4 leading-snug" data-id="element-312">
                {packHelperText[selectedPack]}
              </p>
            </div>
          </div>

          {/* PACK COMPLETE DETAIL */}
          <div className="bg-white border border-[#E7DDD0] rounded-3xl p-8 sm:p-10 mt-8 text-left shadow-sm" data-id="element-313">
            <h3 className="text-xl font-extrabold text-[#2B2330] mb-6 text-center font-['Playfair_Display',serif]" data-id="element-314">
              🏆 El Pack Completo incluye:
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-315">
              <div className="flex items-center gap-3 text-slate-600 text-sm font-semibold" data-id="element-316">
                <div className="w-6 h-6 bg-[#E8623F]/10 border border-[#E8623F]/30 rounded-md flex items-center justify-center text-xs text-[#E8623F] flex-shrink-0" data-id="element-317">
                  ✓
                </div>
                12 tomos completos
              </div>
              <div className="flex items-center gap-3 text-slate-600 text-sm font-semibold" data-id="element-318">
                <div className="w-6 h-6 bg-[#E8623F]/10 border border-[#E8623F]/30 rounded-md flex items-center justify-center text-xs text-[#E8623F] flex-shrink-0" data-id="element-319">
                  ✓
                </div>
                180 fichas con secuencia
              </div>
              <div className="flex items-center gap-3 text-slate-600 text-sm font-semibold" data-id="element-320">
                <div className="w-6 h-6 bg-[#E8623F]/10 border border-[#E8623F]/30 rounded-md flex items-center justify-center text-xs text-[#E8623F] flex-shrink-0" data-id="element-321">
                  ✓
                </div>
                Primaria + Secundaria
              </div>
              <div className="flex items-center gap-3 text-slate-600 text-sm font-semibold" data-id="element-322">
                <div className="w-6 h-6 bg-[#E8623F]/10 border border-[#E8623F]/30 rounded-md flex items-center justify-center text-xs text-[#E8623F] flex-shrink-0" data-id="element-323">
                  ✓
                </div>
                Solucionarios incluidos
              </div>
              <div className="flex items-center gap-3 text-slate-600 text-sm font-semibold" data-id="element-324">
                <div className="w-6 h-6 bg-[#E8623F]/10 border border-[#E8623F]/30 rounded-md flex items-center justify-center text-xs text-[#E8623F] flex-shrink-0" data-id="element-325">
                  ✓
                </div>
                6 Bonus estratégicos
              </div>
              <div className="flex items-center gap-3 text-slate-600 text-sm font-semibold" data-id="element-326">
                <div className="w-6 h-6 bg-[#E0A93B]/20 border border-[#E0A93B]/40 rounded-md flex items-center justify-center text-xs flex-shrink-0" data-id="element-327">
                  ⭐
                </div>
                Ebook Elite: Actos de Autor
              </div>
              <div className="flex items-center gap-3 text-slate-600 text-sm font-semibold" data-id="element-328">
                <div className="w-6 h-6 bg-[#E0A93B]/20 border border-[#E0A93B]/40 rounded-md flex items-center justify-center text-xs flex-shrink-0" data-id="element-329">
                  ⭐
                </div>
                Ebook Elite: ESI + EAI en Música
              </div>
              <div className="flex items-center gap-3 text-slate-600 text-sm font-semibold" data-id="element-330">
                <div className="w-6 h-6 bg-[#E8623F]/10 border border-[#E8623F]/30 rounded-md flex items-center justify-center text-xs text-[#E8623F] flex-shrink-0" data-id="element-331">
                  ✓
                </div>
                Acceso inmediato PDF
              </div>
            </div>
            <div className="text-center mt-8" data-id="element-332">
              <p className="text-[22px] font-black text-[#2B2330] mb-2 font-['Playfair_Display',serif]" data-id="element-333">
                Solo por $27.990 ARS
              </p>
              <p className="text-sm text-slate-600 mb-6" data-id="element-334">
                La opción más elegida por docentes que enseñan en los dos
                niveles
              </p>
              <a href="https://docente360.com.ar/checkouts/cn/hWNEGH8A7rrbt6sXBIIhxzlK/en-ar?_r=AQABU4dTxDRR5QCw-i4Ora25l45Gf5XNKEZnaGUJ1FdZJYw" target="_blank" rel="noopener noreferrer" onClick={() => handleCheckoutClick('completo')} className="inline-block bg-gradient-to-br from-[#E8623F] to-[#D8512F] text-white px-8 py-4 rounded-xl text-lg font-extrabold hover:-translate-y-1 hover:shadow-[0_30px_80px_rgba(232,98,63,0.5)] transition-all tracking-wide animate-[ctaPulse_1.3s_ease-in-out_infinite]" data-id="element-335">
                → SÍ, QUIERO EL PACK COMPLETO
              </a>
            </div>
          </div>

          <div className="flex justify-center gap-4 sm:gap-8 flex-wrap mt-10" data-id="element-336">
            <span className="text-slate-600 text-[13px] flex items-center gap-1.5 font-semibold" data-id="element-337">
              <Lock size={14} data-id="element-338" /> Pago 100% seguro
            </span>
            <span className="text-slate-600 text-[13px] flex items-center gap-1.5 font-semibold" data-id="element-339">
              <Zap size={14} data-id="element-340" /> Acceso en 5 minutos
            </span>
            <span className="text-slate-600 text-[13px] flex items-center gap-1.5 font-semibold" data-id="element-341">
              <Shield size={14} data-id="element-342" /> Garantía 7 días sin preguntas
            </span>
            <span className="text-slate-600 text-[13px] flex items-center gap-1.5 font-semibold" data-id="element-343">
              <CreditCard size={14} data-id="element-344" /> Mercado Pago
            </span>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS FULL */}
      <section className="bg-[#F5EDE3] py-20 px-4" data-id="element-345">
        <div className="max-w-5xl mx-auto text-center" data-id="element-346">
          <div className="inline-block bg-[#E8623F]/10 border border-[#E8623F]/20 text-[#E8623F] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide uppercase mb-6" data-id="element-347">
            Lo que dicen los docentes
          </div>
          <h2 className="text-[clamp(24px,4vw,42px)] font-black mb-12 leading-[1.2] font-['Playfair_Display',serif] text-[#2B2330]" data-id="element-348">
            +1.500 docentes de Argentina
            <br data-id="element-349" />
            ya lo usan
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 text-left" data-id="element-350">
            {[{
            q: '"Lo descargué un sábado a la tarde y el lunes entré al aula con cada grado planificado. Las actividades no son relleno: los chicos enganchan y aprenden de verdad."',
            a: 'PC',
            n: 'Paula C.',
            l: '📍 Córdoba | Docente de Música Primaria'
          }, {
            q: '"Arranqué con Secundaria y a la semana sumé el Pack Completo. Trabajo en los dos niveles y necesitaba todo bajo el mismo criterio. Los Ebooks Elite me resolvieron actos y ESI."',
            a: 'GM',
            n: 'Gabriela M.',
            l: '📍 Mendoza | Docente Primaria y Secundaria'
          }, {
            q: '"Lo que más me sirvió es que viene SECUENCIADO por grado y año. Dejé de improvisar y de adaptar material que no era para el nivel que doy. Todo encaja desde el día uno."',
            a: 'DH',
            n: 'Diego H.',
            l: '📍 Buenos Aires | Docente de Música'
          }, {
            q: '"Pensé que iba a ser un PDF más sacado de internet. Apenas abrí el primer tomo me di cuenta de que está pensado para escuelas argentinas reales, con cursos numerosos y poco tiempo."',
            a: 'CB',
            n: 'Camila B.',
            l: '📍 Tucumán | Docente de Música Primaria'
          }, {
            q: '"Mis chicos de secundaria por fin se enganchan. El material habla de música que escuchan ellos, no de ejemplos viejos. Se terminó el típico ¿esto para qué nos sirve?"',
            a: 'NS',
            n: 'Natalia S.',
            l: '📍 Rosario | Docente de Música Secundaria'
          }, {
            q: '"Presenté la planificación anual la primera semana y la directora me felicitó. Solo personalicé un par de datos del Ebook Elite y quedó impecable en 10 minutos."',
            a: 'JO',
            n: 'Julieta O.',
            l: '📍 Santa Fe | Docente de Música Primaria'
          }].map((t, i) => <div key={i} className="bg-white border border-[#E7DDD0] rounded-2xl p-7 shadow-sm" data-id="element-351">
                <div className="text-[#E0A93B] text-sm tracking-widest mb-3 flex gap-1" data-id="element-352">
                  <Star size={14} fill="currentColor" data-id="element-353" />
                  <Star size={14} fill="currentColor" data-id="element-354" />
                  <Star size={14} fill="currentColor" data-id="element-355" />
                  <Star size={14} fill="currentColor" data-id="element-356" />
                  <Star size={14} fill="currentColor" data-id="element-357" />
                </div>
                <p className="text-[15px] text-slate-600 leading-relaxed mb-5 italic" data-id="element-358">
                  {t.q}
                </p>
                <div className="flex items-center gap-3" data-id="element-359">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E8623F] to-[#D8512F] flex items-center justify-center text-white font-bold text-sm flex-shrink-0" data-id="element-360">
                    {t.a}
                  </div>
                  <div data-id="element-361">
                    <strong className="block text-sm text-[#2B2330] font-bold" data-id="element-362">
                      {t.n}
                    </strong>
                    <span className="text-xs text-slate-500" data-id="element-363">{t.l}</span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="bg-[#FBF7F0] py-20 px-4 text-center" data-id="element-364">
        <div className="max-w-3xl mx-auto bg-white border-2 border-[#E7DDD0] rounded-3xl p-8 sm:p-12 relative shadow-sm" data-id="element-365">
          <span className="text-6xl block mb-6" data-id="element-366">🛡️</span>
          <h2 className="text-[28px] font-black text-[#2B2330] mb-4 font-['Playfair_Display',serif]" data-id="element-367">
            Garantía MegaPack Music Pro
            <br data-id="element-368" />— 7 Días
          </h2>
          <p className="text-base text-slate-600 leading-relaxed mb-6" data-id="element-369">
            Abrís los 12 tomos. Revisás los 6 bonus. Los usás en el aula si
            querés.
            <br data-id="element-370" />
            Si en 7 días no es lo que esperabas:
          </p>
          <div className="flex flex-col gap-3 text-left mb-6 max-w-sm mx-auto" data-id="element-371">
            <div className="flex items-center gap-3 text-[15px] text-slate-600 font-semibold" data-id="element-372">
              <span className="text-[#2E7D32] font-black text-lg" data-id="element-373">✓</span>Te
              devolvemos el 100% del dinero
            </div>
            <div className="flex items-center gap-3 text-[15px] text-slate-600 font-semibold" data-id="element-374">
              <span className="text-[#2E7D32] font-black text-lg" data-id="element-375">✓</span>Sin
              preguntas
            </div>
            <div className="flex items-center gap-3 text-[15px] text-slate-600 font-semibold" data-id="element-376">
              <span className="text-[#2E7D32] font-black text-lg" data-id="element-377">✓</span>Sin
              formularios complicados
            </div>
            <div className="flex items-center gap-3 text-[15px] text-slate-600 font-semibold" data-id="element-378">
              <span className="text-[#2E7D32] font-black text-lg" data-id="element-379">✓</span>Sin
              drama
            </div>
          </div>
          <p className="text-[15px] text-slate-600 leading-relaxed" data-id="element-380">
            La confianza que tenemos en el MegaPack Music Pro nos permite
            ofrecerte eso.
            <br data-id="element-381" />
            Más de 1.500 docentes ya lo saben.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-[#F5EDE3] py-20 px-4" data-id="element-382">
        <div className="max-w-3xl mx-auto text-center" data-id="element-383">
          <div className="inline-block bg-[#E8623F]/10 border border-[#E8623F]/20 text-[#E8623F] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide uppercase mb-6" data-id="element-384">
            Preguntas frecuentes
          </div>
          <h2 className="text-[clamp(24px,4vw,42px)] font-black mb-4 leading-[1.2] font-['Playfair_Display',serif] text-[#2B2330]" data-id="element-385">
            Todo lo que necesitás saber
          </h2>
          <FAQ data-id="element-386" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#FBF7F0] py-10 px-4 text-center border-t border-[#E7DDD0]" data-id="element-387">
        <div className="text-xl font-black bg-gradient-to-br from-[#5B2A4E] to-[#3E1B38] bg-clip-text text-transparent mb-2 font-['Playfair_Display',serif]" data-id="element-388">
          🎵 MegaPack Music Pro
        </div>
        <p className="text-sm text-slate-600 mb-6" data-id="element-389">
          El sistema de planificación N°1 para docentes de Música de primaria y
          secundaria en Argentina.
        </p>
        <p className="text-sm text-slate-500 mb-6 max-w-lg mx-auto" data-id="element-390">
          Porque enseñar Música no debería costarte todos los domingos del año.
        </p>
        <div className="flex justify-center gap-6 flex-wrap mb-6" data-id="element-391">
          <span className="text-xs text-slate-600 font-semibold flex items-center gap-1.5" data-id="element-392">
            <Lock size={12} data-id="element-393" /> Pago seguro
          </span>
          <span className="text-xs text-slate-600 font-semibold flex items-center gap-1.5" data-id="element-394">
            <Zap size={12} data-id="element-395" /> Acceso inmediato
          </span>
          <span className="text-xs text-slate-600 font-semibold flex items-center gap-1.5" data-id="element-396">
            <Shield size={12} data-id="element-397" /> Garantía 7 días
          </span>
          <span className="text-xs text-slate-600 font-semibold flex items-center gap-1.5" data-id="element-398">
            <CreditCard size={12} data-id="element-399" /> Mercado Pago
          </span>
        </div>
        <p className="text-xs text-slate-400" data-id="element-400">
          © MegaPack Music Pro — Profe Listo. Todos los derechos reservados.
        </p>
      </footer>
    </div>;
}